import React from "react";
import "./NotificationModal.css";
import checkIcon from "../../assets/CheckExito/CheckBox.svg";

function NotificationModal({ isOpen, onClose, title, buttonText, onAction }) {
  if (!isOpen) return null;

  // Verificamos si queremos el modo "pago" (que lleva el SVG/icono gigante en vez de botón clásico)
  const isBigIconMode = !buttonText; 

  return (
    <div className="notif-modal-overlay" onClick={onClose}>
      <div className="notif-modal-content" onClick={(e) => e.stopPropagation()}>
        
        {/* Botón circular superior derecho (X) */}
        <button className="notif-modal-close" onClick={onClose}>
          ✕
        </button>

        {/* Título de la notificación */}
        <h2 className="notif-modal-title">
          {/* Icono de check pequeño que acompaña al texto en la mayoría de diseños */}
          {!isBigIconMode && (
            <img src={checkIcon} alt="Check" style={{width: "25px"}} />
          )}
          {title}
        </h2>

        {/* Sección inferior dinámica */}
        <div className="notif-modal-action-container">
          {isBigIconMode ? (
            /* Caja del Check gigante para Pago Exitoso */
            <div className="notif-modal-big-icon" onClick={onAction || onClose}>
              <img src={checkIcon} alt="Check" />
            </div>
          ) : (
            /* Botón clásico (Aceptar / Cerrar) */
            <button className="notif-modal-btn" onClick={onAction || onClose}>
              {buttonText}
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

export default NotificationModal;